import { useLayoutEffect } from 'react';
import { useSelector } from 'react-redux';

import { getCurrencySymbol, getCurrencySymbolFontFamily } from '@helpers/currency';

import { getCurrencyState, getLocaleState } from '@redux/selectors';

/**
 * Temporary hook to replace the currency symbol with the custom symbol for AED and SAR currencies.
 */
export const useCustomCurrencySymbolMutation = () => {
  const currency = useSelector(getCurrencyState);
  const locale = useSelector(getLocaleState);

  useLayoutEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          const nodes = document.createNodeIterator(
            mutation.target as Node,
            NodeFilter.SHOW_TEXT,
            null,
          );

          let node;
          while ((node = nodes.nextNode())) {
            const text = node.textContent || '';

            const regex = /(AED|SAR)\s*(\d+(?:\.\d+)?)/g;

            if (regex.test(text)) {
              const fontFamily = getCurrencySymbolFontFamily(currency, locale);

              if (fontFamily) {
                node.parentElement?.style.setProperty(
                  'font-family',
                  `${fontFamily}, 'Inter', 'Geeza Pro', sans-serif`,
                );
              }

              const newText = text.replace(
                regex,
                (_, symbol, price) => `${getCurrencySymbol(currency, locale)}${price}`,
              );

              if (newText !== text) {
                node.textContent = newText;
              }
            }
          }
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);
};
